import { render } from "./PageBaseLayout.vue?vue&type=template&id=148daecc&scoped=true"
import script from "./PageBaseLayout.vue?vue&type=script&lang=js"
export * from "./PageBaseLayout.vue?vue&type=script&lang=js"

import "./PageBaseLayout.vue?vue&type=style&index=0&id=148daecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148daecc"]])

export default __exports__